import React from "react";
import { Button, Label } from "reactstrap";
import { Input } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import NkTable from "../../users/nktable";
import moment from "moment";
import Loading from "../../loader/loader";
import "./addmoducle.scss";

const addModal = (props) => {
  const columns = [
    {
      dataField: "citizenId",
      text: "Citizen Id",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "mobileNumber",
      text: "Phone Number",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "branchId",
      text: "Branch Id",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "registrationDate",
      text: "Registration Date",
      sort: true,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "220px", textAlign: "center" },
      formatter: (cell, row) => {
        return moment((row && row.registrationDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
  ];
  const options = [
    {
      value: "MobileRecharge",
      label: "Mobile Recharge Phone Number",
    },
    {
      value: "MoneyTransferAccountNumber",
      label: "Money Transfer Account Number",
    },
  ];
  const getPopupHeader = () => {
    return (
      <div className="summary-header">
        <h1>Summary:</h1>
        <h3 style={{ borderBottom: "1px solid gray" }}>
          Black Listed Entity Details
        </h3>
        <div>
          <Label>
            Type: {props.type && props.type.length ? props.type[0].label : "-"}
          </Label>
        </div>
        <div>
          <Label>
            Identifier: <span>{props.identyId ? props.identyId : "-"}</span>
          </Label>
        </div>
      </div>
    );
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
    >
      <Modal.Header className="block-list-popup-header" closeButton>
        <Modal.Title
          className="block-list-popup-title"
          id="contained-modal-title-vcenter"
        >
          {props.blockbutton ? getPopupHeader() : "New Black Listed Entity"}
        </Modal.Title>
      </Modal.Header>
      {!props.blockbutton && (
        <>
          {" "}
          <Modal.Body>
            <div style={{ marginBottom: 15 }}>
              <Select
                closeMenuOnSelect={true}
                placeholder="Entity Type"
                onChange={props.handleChange}
                options={options}
                value={props.type}
              />
            </div>
            <div style={{ marginBottom: 15 }}>
              <Select
                closeMenuOnSelect={true}
                placeholder="Country"
                onChange={props.handleCountryChange}
                options={props.countryList}
                value={props.country}
              />
            </div>
            <Input
              id="example3cols2Input"
              maxlength = "100"
              placeholder={
                props.type && props.type.length > 0
                  ? props.type[0].value === "MobileRecharge"
                    ? "9715012345"
                    : "17559879157312471 or PK33BUKB20201555555555"
                  : "Entity Identifier"
              }
              style={{ height: "40px" }}
              onChange={props.idinputOnchange}
              value={props.identyId ? props.identyId : ""}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              color="primary"
              disabled={
                !(
                  props.type &&
                  props.type.length > 0 &&
                  props.country &&
                  props.country.length > 0 &&
                  props.identyId &&
                  props.identyId.length > 0
                )
              }
              onClick={props.search}
            >
              {props.searchdataLoading ? (
                <Loading color="white" width="15px" height="15px" />
              ) : (
                "Next"
              )}
            </Button>
          </Modal.Footer>
        </>
      )}

      {props.blockbutton && (
        <Modal.Body>
          <h1 style={{ borderBottom: "1px solid gray" }}>Associated Users</h1>
          <div className="col card-parent" style={{ overflow: "auto" }}>
            <NkTable
              dataexcal
              filename={"searchblocklist"}
              data={props.searchblockList}
              columns={columns}
              pagination=""
              clientSide={false}
            />
          </div>
          <div>
            <span style={{ fontWeight: "bold" }}>Note:</span> By clicking
            finish, the entity will be black listed and the users associated
            with it will be blocked
          </div>
        </Modal.Body>
      )}

      {props.blockbutton && (
        <Modal.Footer>
          <Button variant="secondary" onClick={props.back}>
            Back
          </Button>
          <Button
            variant="primary"
            color="primary"
            onClick={props.handlesaveBlocklist}
          >
            {props.searchdataLoading ? (
              <Loading color="white" width="15px" height="15px" />
            ) : (
              "Finish"
            )}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default addModal;
